import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DishServices } from "../../../../dish/services";
import { Globals } from "../../../../../globals";
import { MenuServices } from "../../../services";
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateDishPage } from '../../../../components/popups/create-dish/create-dish';
import { AnalyticsServices } from '../../../../services/analyticsServices';
/**
 * Generated class for the MenuPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-partial-dishes-select',
    templateUrl: 'menu-partial-dishes-select.html',
})
export class MenuPartialDishesSelectPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public menuServices: MenuServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public translate: TranslateService,
        public modalCtrl: ModalController,
        public analyticsServices: AnalyticsServices) {
    }

    insert(element) {
        //Funcion que añadir al array de elementos seleccionados para el menu
        if (!this.check(element.UID)) { //Buscamos si el elemento ya esta anadido
            this.analyticsServices.trackingExp('entrar plato a menu', this.globals.tracking_exp['insert_element_menu'], '');
            var _array = Array();
            //añadir un if para saber si elemento es dish o product
            if (element.type == 'dish') {
                _array.push(element.UID); //UID
                _array.push(this.menuServices.menu_dish_array_tmp.length + 1); //Order
                _array.push(element.name_es);
                _array.push(element.name_ca);
                _array.push(element.name_en);
                _array.push(element.name_de);
                _array.push(element.name_fr);
                _array.push(element.name_it);
                if (element.allergens) {
                    _array.push(element.allergens);
                } else {
                    _array.push([]);
                }
                if (element.foodcost_static) {
                    _array.push(element.foodcost_static);
                } else {
                    _array.push(0);
                }
                if (element.foodcost_parts) {
                    _array.push(element.foodcost_parts);
                } else {
                    _array.push(0);
                }
                _array.push('dish');
                _array.push(element.price);
                if (element.price_combo_extra) {
                    _array.push(element.price_combo_extra);
                } else {
                    _array.push(0);
                }
                if (element.price_takeaway) {
                    _array.push(element.price_takeaway);
                } else {
                    _array.push(0);
                }
                _array.push(element.description_es);
                _array.push(element.description_ca);
                _array.push(element.description_en);
                _array.push(element.description_de);
                _array.push(element.description_fr);
                _array.push(element.description_it);

                _array.push(element.tags);

                if (element.price_supplement) {
                    _array.push(element.price_supplement);
                } else {
                    _array.push(0);
                }

                let toast = this.toastCtrl.create({
                    message: this.translate.instant('general-plato') + ' ' + this.globals.nameLangSelectDish(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();

            } else {
                _array.push(element.UID); //UID
                _array.push(this.menuServices.menu_dish_array_tmp.length + 1); //Order
                _array.push(element.name);
                _array.push(element.name_ca);
                _array.push(element.name_en);
                _array.push(element.name_de);
                _array.push(element.name_fr);
                _array.push(element.name_it);
                if (element.allergens) {
                    _array.push(element.allergens);
                } else {
                    _array.push([]);
                }
                if (element.price_static) {
                    _array.push(element.price_static);
                } else {
                    _array.push(0);
                }
                if (element.foodcost_parts) {
                    _array.push(element.foodcost_parts);
                } else {
                    _array.push(1);
                }
                _array.push('product');
                _array.push(element.pvp);
                if (element.pvp_combo_extra) {
                    _array.push(element.pvp_combo_extra);
                } else {
                    _array.push(0);
                }
                if (element.pvp_takeaway) {
                    _array.push(element.pvp_takeaway);
                } else {
                    _array.push(0);
                }
                _array.push(element.description_es);
                _array.push(element.description_ca);
                _array.push(element.description_en);
                _array.push(element.description_de);
                _array.push(element.description_fr);
                _array.push(element.description_it);

                _array.push(element.tags);

                if (element.pvp_supplement) {
                    _array.push(element.pvp_supplement);
                } else {
                    _array.push(0);
                }

                let toast = this.toastCtrl.create({
                    message: this.translate.instant('general-producto') + ' ' + this.globals.nameLangSelectProduct(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            }
            this.menuServices.menu_dish_array_tmp.push(_array);
            this.menuServices.menu_dish_array_tmp = [...this.menuServices.menu_dish_array_tmp];
            //
            if (this.globals.tour != '' && this.globals.tour_step_user == 7) {
                this.globals.tour_step_user = 8;
            } else if (this.globals.tour != '' && this.globals.tour_step_user == 10) {
                this.globals.tour_step_user = 11;
            } else if (this.globals.tour != '' && this.globals.tour_step_user == 12) {
                this.globals.tour_step_user = 13;
            }

        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-plato-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.menuServices.menu_dish_array_tmp.length; i++) {
            var obj = this.menuServices.menu_dish_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }
    nextPage() {
        if (this.menuServices.page_active < this.menuServices.pagesDishesProducts.length) {
            this.menuServices.page_active += 1
        }
        this.menuServices.getListDishesProductsMinMax();
        document.getElementById('scroll_menu_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    previusPage() {
        if (this.menuServices.page_active > 1) {
            this.menuServices.page_active -= 1;
        }
        this.menuServices.getListDishesProductsMinMax();
        document.getElementById('scroll_menu_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    activePage(number) {
        this.menuServices.page_active = number;
        this.menuServices.getListDishesProductsMinMax();
        document.getElementById('scroll_menu_select').scrollIntoView({
            behavior: 'smooth'
        });
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }
    createDish() {
        //open create dish
        let profileModal = this.modalCtrl.create(CompCreateDishPage, {
            origin: 'menu'
        });
        profileModal.present();
    }
}


// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-dish-select/menu-partial-dishes-select/menu-partial-dishes-select.ts